import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlVideoCardProps, CardTags } from './card.types.ts';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement(CardTags.VideoCard)
export class AtlVideoCard extends LitElement implements AtlVideoCardProps {
   declare srcUrl?: string;
   declare videoTitle?: string;
   declare allowFullScreen?: boolean;

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   static properties = {
      srcUrl: { attribute: 'src-url', type: String },
      videoTitle: { attribute: 'video-title', type: String },
      allowFullScreen: { attribute: 'allow-fullscreen', type: Boolean },
   };

   render() {
      const allowList = [
         'accelerometer',
         'clipboard-write',
         'encrypted-media',
         'gyroscope',
         'picture-in-picture',
      ];
      if (this.allowFullScreen) {
         allowList.push('fullscreen');
      }
      return html`
         <div class="card video-card">
            <div class="card-body">
               <iframe
                  class="video-player"
                  src="${ifDefined(this.srcUrl)}"
                  frameborder="0"
                  title=${ifDefined(this.videoTitle)}
                  allow=${allowList.join('; ')}
               >
               </iframe>
            </div>
         </div>
      `;
   }
}
